import sso from '@/services/SSOService';
import AuthService from '@/services/AuthService';

export default {
  async getToken (query) {
    const { oneTimeToken } = query;

    const responseBody = await sso.verifyVerificationTokenRedirect(oneTimeToken, {
      hideErrorMessage: true,
    });

    AuthService.loginWithToken(responseBody);

    return '';
  },
  redirectUrlGenerator ({ query }) {
    return query.redirect || '/dashboard';
  },
  getGtmEvent () {
    return {
      event: 'GAEvent',
      eventCategory: 'AccountSSOPage',
      action: 'Login With Token SSO',
      eventLabel: '',
    };
  },
  getErrorModalConfig () {
    return {
      buttonText: 'Tamam',
      redirect: '/account/login',
    };
  },
};
